import { render, staticRenderFns } from "./index.vue?vue&type=template&id=50f33a5e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f33a5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\english\\new-evaluation\\src\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50f33a5e')) {
      api.createRecord('50f33a5e', component.options)
    } else {
      api.reload('50f33a5e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=50f33a5e&scoped=true&", function () {
      api.rerender('50f33a5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/rate/index.vue"
export default component.exports